export default "__VITE_ASSET__18f8f1d2__"